import { createSlice } from "@reduxjs/toolkit";

const navSlice = createSlice({
  name: "nav",
  initialState: {
    value: true,
  },
  reducers: {
    setNav: (state, action) => {
      state.value = action.payload;
    },
  },
});
export const { setNav } = navSlice.actions;
export default navSlice.reducer;
